import React from "react";
import { Table } from "antd";
import { Popover, Button, Icon } from "antd";
import { Popconfirm } from "antd";
import getOr from "lodash/fp/getOr";

const { Column } = Table;

const ScenarioTable = ({
  scenarioSet,
  licenseSet,
  user,
  loading,
  onShow,
  onShowSessionData,
  onEdit,
  onDelete,
}) => {
  const licenseName = (id) =>
    getOr(
      "",
      "0.name",
      licenseSet.filter((row) => row.id === id)
    );
  return (
    <Table
      rowKey="id"
      dataSource={scenarioSet}
      size="middle"
      pagination={false}
      bordered={false}
      loading={loading}
    >
      <Column
        title="Name"
        dataIndex="name"
        render={(value, row) =>
          row.description ? (
            <Popover content={row.description} title="Description">
              {value}
            </Popover>
          ) : (
            value
          )
        }
        sorter={(a, b) => a.name.localeCompare(b.name)}
      />
      <Column
        title="License"
        dataIndex="licenseId"
        sorter={(a, b) =>
          licenseName(a.licenseId).localeCompare(licenseName(b.licenseId))
        }
        render={licenseName}
      />
      <Column
        title="Action"
        key="action"
        render={(row) => {
          // allow only admin users and scenario owners to edit scenario
          const allowShow = true;
          const allowShowSessionData = true;
          const allowEdit = user.isAdmin || user.licenseId === row.licenseId;
          const allowDelete = user.isAdmin || user.licenseId === row.licenseId;
          return (
            <Button.Group size="small">
              {allowShow && (
                <Button onClick={() => onShow(row)}>
                  <Icon type="eye" />
                </Button>
              )}
              {allowShowSessionData && (
                <Button onClick={() => onShowSessionData(row)}>
                  <Icon type="table" />
                </Button>
              )}
              {allowEdit && (
                <Button onClick={() => onEdit(row)}>
                  <Icon type="edit" />
                </Button>
              )}
              {allowDelete && (
                <Popconfirm
                  onConfirm={() => onDelete(row)}
                  title="Do you really want to delete this license?"
                  okText="Yes"
                  cancelText="No"
                  placement="left"
                >
                  <Button type="danger">
                    <Icon type="delete" />
                  </Button>
                </Popconfirm>
              )}
            </Button.Group>
          );
        }}
      />
    </Table>
  );
};

export default ScenarioTable;
